export const WEIGHING_TYPES = {
  RECEPTION: 1,
  SALES: 2,
  TRANSFER: 3,
  REQUALIFICATION: 4,
  CONTRACTED_MEASUREMENTS: 5,
  FIELD_REPORT: 6,
};

export const FIELD_REPORT_MODES = {
  SIMPLE: 1,
  WITH_SALE: 2,
  WITH_SALE_AND_INTERMEDIARY: 3,
  WEIGHING_FOR_TRANSPORT: 4,
};
